<mat-card>{{'assistanceDirectCharge' | translate}}</mat-card>



<div class="container" style="padding: 25px;">

    <mat-grid-list cols="4" rowHeight="50px">

        <mat-grid-tile>
            <mat-form-field appearance="standard" style="margin: 10px;">
                <mat-label>{{'user' | translate}}</mat-label>
                <input type="text" matInput [formControl]="searchCategory" required [matAutocomplete]="auto">
                <button mat-button matSuffix mat-icon-button>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectUserChange($event.option.value)"
                    [displayWith]="displayFn">
                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                        <span>{{option.fullName}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </mat-grid-tile>


        <mat-grid-tile>
            <button mat-raised-button color="primary" (click)="save()">
                <mat-icon>save</mat-icon>
                {{'submit' | translate}}
            </button>
        </mat-grid-tile>

        <mat-grid-tile>

        </mat-grid-tile>

    </mat-grid-list>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'categories' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.arabicName}} </td>
            </ng-container>

            <ng-container matColumnDef="view">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'select' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox class="example-margin" [(ngModel)]="row.userPermission"></mat-checkbox>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}</td>
            </tr>
        </table>

        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>